import { computed } from 'vue'
import { useUser } from '@clerk/vue'
import { isAuthMocked } from '@/lib/env'

export function useIsAdmin() {
  if (isAuthMocked) {
    return { isAdmin: computed(() => true) }
  }

  const { user } = useUser()

  const isAdmin = computed(() => {
    const role = user.value?.publicMetadata?.role
    return role === 'admin'
  })

  return { isAdmin }
}
